import { axiosApiInstance } from "./HttpService";
import { CreditFlowTokenResponseDto, CreditFlowAvailabilityDto } from "../models/CreditFlow";

export class CreditFlowService {
    public static async getCreditFlowToken(): Promise<CreditFlowTokenResponseDto> {
        let dataURL: string = `${process.env.REACT_APP_API_URL}/api/CreditFlow/getCreditFlowToken`;
        return (await axiosApiInstance.post(dataURL)).data;
    }

    // Gating liviano para el menú: se llama por separado del login, no bloquea el ingreso.
    public static async isAvailable(): Promise<CreditFlowAvailabilityDto> {
        let dataURL: string = `${process.env.REACT_APP_API_URL}/api/CreditFlow/isAvailable`;
        return (await axiosApiInstance.get(dataURL)).data;
    }
}
